export const reference = [
  {
    id: 1,
    name: "naming Conventions - ",
    title: "Decide what to call your service users and carers",
  },
  {
    id: 2,
    name: "AnalysisAreas-",
    title:
      "You can set up all your core actions with text, icons and checklists. This saves you time creating the same actions for multiple Service Users",
  },
  {
    id: 3,
    name: "SessionType-",
    title:
      "You can set up the types of learning and development sessions you want to record case notes for, such as occupational therapy, physiotherapy etc.",
  },
  {
    id: 4,
    name: "User Roles - ",
    title:
      "Define the roles for your team and define whether the role needs to read care plans",
  },
  {
    id: 5,
    name: "Consent Reason - ",
    title: "Build a list consent reasons that work for your business",
  },
  {
    id: 6,
    name: "Risk type - ",
    title: "Set up type of risks you want to record and report on",
  },
  {
    id: 7,
    name: "Bank Holidays - ",
    title: "Set up bank holiday dates",
  },
  {
    id: 8,
    name: "NonCore Activity Types-",
    title:
      "Define all activities your team may do when not directly caring, such as meetings or doctors appointments",
  },
  {
    id: 9,
    name: "Initial Assessment Checks-",
    title:
      "You can define the checks and information that you need to record when you initially meet your Service User",
  },
  {
    id: 10,
    name: "Infection Type -",
    title:
      "Set up type of infections you want to record and report on for your Service User",
  },
  {
    id: 11,
    name: "Vaccination Types - ",
    title: "Set up types of vaccinations for users and carers",
  },
  {
    id: 12,
    name: "Medical Conditions- ",
    title: "Set up type of medical conditions you want to record and report on",
  },
  {
    id: 13,
    name: "Danage Improvement Area - ",
    title: "Improvement Areas Description",
  },
  {
    id: 14,
    name: "Behaviour Types - ",
    title: "Set up types of behaviours for physical interventions",
  },

  {
    id: 15,
    name: "Physical Interventions - ",
    title:
      "Set up type of physical interventions you want to record and report on",
  },
  {
    id: 16,
    name: "Document Tag - ",
    title: "Set up type of documents you want to record and report on",
  },
  {
    id: 17,
    name: "Service User Extra Reference Fields - ",
    title: "Set up Service User Extra Reference Fields",
  },
];

export const preset = [
  {
    id: 1,
    name: "Care Plan Text ",
    title:
      " Set up all the pre-set data you want to appear in your care plans and risks - this makes care plans consistent and fast to build",
  },
  {
    id: 2,
    name: "Preset Actions ",
    title:
      "You can set up all your core actions with text, icons, checklists. This saves you time creating the same action for multiple Service Users",
  },
  {
    id: 3,
    name: "Checklists  ",
    title:
      "You can add up standard checklists to add to actions or use as stand alone checklists",
  },
];

export const employeeAudit = [
  {
    id: 1,
    name: "Carer Activity Summary Report - ",
    title:
      "reports on the actions completed by Employee and the notes they left",
  },
  {
    id: 2,
    name: "Care Plan Read Report - ",
    title:
      "lists out the Employee and when they last read the care plans for Employee",
  },
  {
    id: 3,
    name: "Compliance Report - ",
    title:
      "shows certifications/skills that are nearing or past their expiry date",
  },
  {
    id: 4,
    name: "Staff Analysis Reports - ",
    title:
      "this highlights all items that are overdue or nearing like Reviews, Skills, Work Certification and Compliance.",
  },
];
